export default __webpack_public_path__ + "static/media/Ballroll_00050.393c94a7.png";